import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n/index';

// 提示框 - Vue 3 版本
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import { ElProgress } from 'element-plus';
import './errorLog';
import svgIconPlugin from './icons';
import LoadingDirective from './directives/loading';

const options = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  // 其他可选配置
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
};

const app = createApp(App);

// 注册 Element Plus 组件
app.component(ElProgress.name, ElProgress);

app.use(router);
// 挂载后检查当前路由
// router.isReady().then(() => {
//   console.log('Current route:', router.currentRoute.value);
// });
// // 添加路由调试
// router.beforeEach((to, from, next) => {
//   console.log('路由跳转:', from.path, '->', to.path);
//   console.log('匹配的路由:', to.matched);
//   next();
// });

// router.afterEach((to, from) => {
//   console.log('路由跳转完成:', to.path);
//   console.log('当前路由:', router.currentRoute.value);
// });
app.use(store);
app.use(i18n);
app.use(Toast, options);
app.use(svgIconPlugin); // 使用svg图标插件
// 注册全局指令
app.use(LoadingDirective);

app.mount('#app');
